import { setupNextraPage } from 'nextra/setup-page'

/*@jsxRuntime automatic @jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
export const __toc = [{
  depth: 2,
  value: "Doctype",
  id: "doctype"
}, {
  depth: 2,
  value: "Balise html",
  id: "balise-html"
}, {
  depth: 2,
  value: "Balise head",
  id: "balise-head"
}, {
  depth: 2,
  value: "Balise body",
  id: "balise-body"
}, {
  depth: 2,
  value: "Exemple complet",
  id: "exemple-complet"
}, {
  depth: 2,
  value: "Conclusion",
  id: "conclusion"
}];
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    h2: "h2",
    pre: "pre",
    code: "code",
    span: "span"
  }, _provideComponents(), props.components);
  return <><_components.h1>{"Structure d'un document HTML de base"}</_components.h1>{"\n"}<_components.p>{"Un document HTML de base suit une structure bien définie pour assurer une mise en page cohérente et sémantique. Voici un aperçu de la structure d'un document HTML de base :"}</_components.p>{"\n"}<_components.h2 id="doctype">{"Doctype"}</_components.h2>{"\n"}<_components.p>{"La première ligne d'un document HTML contient une déclaration du type de document (Doctype). Il s'agit d'une instruction spéciale qui indique au navigateur quelle version d'HTML est utilisée. Par exemple, pour HTML5, la déclaration est la suivante :"}</_components.p>{"\n"}<_components.pre data-language="html" data-theme="default" hasCopyCode><_components.code data-language="html" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<!"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"doctype"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"html"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.h2 id="balise-html">{"Balise "}<_components.code>{"html"}</_components.code></_components.h2>{"\n"}<_components.p>{"La balise "}<_components.code>{"<html>"}</_components.code>{" est l'élément racine de tout document HTML. Elle englobe tout le contenu de la page et indique au navigateur que le document est écrit en HTML."}</_components.p>{"\n"}<_components.pre data-language="html" data-theme="default" hasCopyCode><_components.code data-language="html" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<!"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"doctype"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"html"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"html"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"<!-- Le contenu de la page -->"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"html"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.h2 id="balise-head">{"Balise "}<_components.code>{"head"}</_components.code></_components.h2>{"\n"}<_components.p>{"La balise "}<_components.code>{"<head>"}</_components.code>{" est utilisée pour contenir des informations sur le document, telles que le titre de la page, les liens vers des fichiers CSS ou JavaScript, les métadonnées, etc. Cette section n'est pas visible à l'écran."}</_components.p>{"\n"}<_components.pre data-language="html" data-theme="default" hasCopyCode><_components.code data-language="html" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<!"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"doctype"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"html"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"html"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"head"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"<!-- Informations sur le document -->"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"head"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"html"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.h2 id="balise-body">{"Balise "}<_components.code>{"body"}</_components.code></_components.h2>{"\n"}<_components.p>{"La balise "}<_components.code>{"<body>"}</_components.code>{" contient le contenu visible de la page web. C'est là que vous placez les éléments tels que les titres, les paragraphes, les images, les liens et tout autre élément interactif."}</_components.p>{"\n"}<_components.pre data-language="html" data-theme="default" hasCopyCode><_components.code data-language="html" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<!"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"doctype"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"html"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"html"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"head"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"<!-- Informations sur le document -->"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"head"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"body"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"<!-- Contenu visible de la page -->"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"body"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"html"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.h2 id="exemple-complet">{"Exemple complet"}</_components.h2>{"\n"}<_components.p>{"Voici un exemple complet d'un document HTML de base :"}</_components.p>{"\n"}<_components.pre data-language="html" data-theme="default" hasCopyCode><_components.code data-language="html" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<!"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"doctype"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"html"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"html"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"head"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"title"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Titre de la page</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"title"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"link"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"rel"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"stylesheet\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"href"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"styles.css\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" />"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"script"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"src"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"script.js\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"></"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"script"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"head"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"body"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"h1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Titre principal</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"h1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"p"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Ceci est un paragraphe.</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"p"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"img"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"src"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"image.jpg\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"alt"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Description de l'image\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" />"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"a"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"href"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"https://www.example.com\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Lien vers Example</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"a"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"body"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"html"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.h2 id="conclusion">{"Conclusion"}</_components.h2>{"\n"}<_components.p>{"La structure d'un document HTML de base est essentielle pour créer des pages web bien organisées et cohérentes. En comprenant la structure et l'utilisation des balises HTML telles que "}<_components.code>{"<!DOCTYPE html>"}</_components.code>{", "}<_components.code>{"<html>"}</_components.code>{", "}<_components.code>{"<head>"}</_components.code>{", et "}<_components.code>{"<body>"}</_components.code>{", vous êtes en mesure de définir la structure et le contenu d'une page web."}</_components.p>{"\n"}<_components.p>{"La balise "}<_components.code>{"<head>"}</_components.code>{" permet d'inclure des informations importantes pour le document, tandis que la balise "}<_components.code>{"<body>"}</_components.code>{" contient le contenu visible de la page. En utilisant les balises HTML appropriées, telles que les titres "}<_components.code>{"<h1>"}</_components.code>{" à "}<_components.code>{"<h6>"}</_components.code>{", les paragraphes "}<_components.code>{"<p>"}</_components.code>{", les liens "}<_components.code>{"<a>"}</_components.code>{", les images "}<_components.code>{"<img>"}</_components.code>{", et bien d'autres encore, vous pouvez organiser et formater votre contenu de manière claire et sémantique."}</_components.p>{"\n"}<_components.p>{"N'oubliez pas que la structure d'un document HTML est la base sur laquelle vous pouvez construire des pages web plus complexes. En combinant différentes balises HTML et en utilisant des attributs, vous pouvez créer des mises en page avancées, intégrer des médias, et ajouter des interactions avec des langages de programmation comme JavaScript."}</_components.p>{"\n"}<_components.p>{"En continuant votre apprentissage d'HTML et en explorant les différentes balises et fonctionnalités, vous développerez des compétences solides pour concevoir et construire des sites web professionnels et efficaces."}</_components.p></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}



const __nextraPageOptions = {
  MDXContent,
  pageOpts: {"filePath":"pages/cours/html/00-introduction/0-2-structure-dun-document-html-de-base.mdx","route":"/cours/html/00-introduction/0-2-structure-dun-document-html-de-base","title":"Structure d'un document HTML de base",headings:__toc},
  pageNextRoute: "/cours/html/00-introduction/0-2-structure-dun-document-html-de-base",
  
}
if (process.env.NODE_ENV !== 'production') {
  __nextraPageOptions.hot = module.hot
  __nextraPageOptions.pageOptsChecksum = ''
}
if (typeof window === 'undefined') __nextraPageOptions.dynamicMetaModules = []

export default setupNextraPage(__nextraPageOptions)